import React from 'react';
import Container from 'react-bootstrap/Container';
import styles from './EAAFooterPage.module.scss'; // Assuming you have a CSS module for styles

const EAAFooterPage = () => {
  return (
    <Container>
      <div className={styles.container}>
        <h2>Barrierefreiheitserklärung</h2>
        <p>Die tmc Media Group AG ist bemüht, die Webseite www.bluemovie.com im Einklang mit den Bestimmungen des
          <span style={{fontWeight:'bolder'}}> Barrierefreiheitsstärkungsgesetzes (BFSG) </span> und der Verordnung zum <span style={{ fontWeight: 'bolder' }}> Barrierefreiheitsstärkungsgesetz (BFSGV)</span> zur
          Umsetzung der Richtlinie (EU) 2019/882 (European Accessibility Act, EAA) barrierefrei zugänglich zu machen.

          Die Webseite entspricht im Wesentlichen den geltenden Anforderungen zur Barrierefreiheit. An einer weiteren
          Optimierung und Verbesserung der Zugänglichkeit wird kontinuierlich gearbeitet.</p>
        <h3>Maßnahmen zur Barrierefreiheit</h3>
        <p>Die Webseite www.bluemovie.com ist so gestaltet, dass sie mit gängigen assistiven Technologien kompatibel
          ist.
          Klare Strukturen, gut lesbare Schriftarten und ausreichende Farbkontraste werden fortlaufend optimiert.
          Inhalte
          und Navigation sind grundsätzlich auch per Tastatur zugänglich.</p>
        <h3>Nicht vollständig barrierefreie Inhalte</h3>
        <ul>
          <li>Audioguidance</li>
          <li> Audiodescription</li>
        </ul>
        <h3>Datum der Erstellung</h3>
        <p>Diese Erklärung wurde am 23. Juni 2025 erstellt.</p>
        <h3>Kontakt</h3>
        <p>Sollten Ihnen Barrieren oder Zugänglichkeitsprobleme auf www.bluemovie.com auffallen, können Sie uns
          jederzeit per E-Mail kontaktieren: <span style={{ fontWeight: 'bolder' }}>support@bluemovie.com</span></p>
      </div>
    </Container>
  );
};

export default EAAFooterPage;
